import $ from 'jquery';
import BlogLayout from '../snippets/BlogLayout';

export default class StaticBlog {
  constructor(section) {
    this.$articles = $('[data-article-excerpts]', section.el);
    this.blogLayout = new BlogLayout(this.$articles);
  }

  onSectionUnload() {
    this.blogLayout.unload();
  }
}
